import { useState, useEffect } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Clock, Info } from "lucide-react";

const TIMES = [10, 15, 20, 25, 30, 35, 40, 45, 50, 60, 70, 80, 90];

function TimeGrid({ value, onChange }) {
  return (
    <div className="grid grid-cols-4 gap-2">
      {TIMES.map(m => (
        <button
          key={m}
          onClick={() => onChange(m)}
          className={`py-2 rounded-lg text-sm font-bold transition-colors ${
            value === m
              ? "bg-emerald-600 text-white shadow-sm"
              : "bg-gray-100 text-gray-700 hover:bg-emerald-50 hover:text-emerald-700"
          }`}
        >
          {m}m
        </button>
      ))}
    </div>
  );
}

export function DeliveryTimeModal({ open, onClose, deliveryTime, pickupTime, onSave, saving }) {
  const [selDelivery, setSelDelivery] = useState(deliveryTime ?? 40);
  const [selPickup, setSelPickup] = useState(pickupTime ?? deliveryTime ?? 20);

  // Sync when modal opens with fresh values
  useEffect(() => {
    if (open) {
      setSelDelivery(deliveryTime ?? 40);
      setSelPickup(pickupTime ?? deliveryTime ?? 20);
    }
  }, [open, deliveryTime, pickupTime]);

  const handleSave = () => onSave({ delivery: selDelivery, pickup: selPickup });

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-sm">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Clock className="w-4 h-4 text-emerald-600" />
            Tempo de espera
          </DialogTitle>
        </DialogHeader>

        <div className="space-y-5 py-1">
          <div className="flex items-start gap-2 bg-blue-50 border border-blue-100 rounded-lg p-3">
            <Info className="w-4 h-4 text-blue-500 mt-0.5 shrink-0" />
            <p className="text-xs text-blue-700">Este tempo será exibido para o cliente no site.</p>
          </div>

          <div>
            <div className="flex items-center justify-between mb-2">
              <p className="text-xs font-bold uppercase text-gray-500 tracking-wide">Delivery</p>
              <span className="text-sm font-bold text-emerald-700">{selDelivery} min</span>
            </div>
            <TimeGrid value={selDelivery} onChange={setSelDelivery} />
          </div>

          <div>
            <div className="flex items-center justify-between mb-2">
              <p className="text-xs font-bold uppercase text-gray-500 tracking-wide">Pickup / Recolha</p>
              <span className="text-sm font-bold text-emerald-700">{selPickup} min</span>
            </div>
            <TimeGrid value={selPickup} onChange={setSelPickup} />
          </div>
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={onClose}>Cancelar</Button>
          <Button
            className="bg-emerald-600 hover:bg-emerald-700"
            onClick={handleSave}
            disabled={saving}
          >
            {saving ? "Salvando..." : "Salvar"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
